import { Component, Input } from '@angular/core';
import { IStatus } from './models/status.model';

@Component({
    selector: 'app-tqw-status',
    templateUrl: './tqw-status.component.html',
    styleUrls: ['./tqw-status.component.scss']
})
export class TqwStatusComponent {
    @Input() config!: IStatus;
    removeSpaces(className: string): string {
        return (className).replace(/\s+/g, '').trim();
    }
}
